import React from 'react';

export default class ReviewerIsCallerConditionComponent extends React.Component {
  render() {
    const {context} = this.props;
    return (
      <div>
        {context.negated && (
          <span>
            the reviewer{' '}
            <span onClick={this.props.onClick} className="condition-action">
              is not the caller
            </span>
          </span>
        )}
        {!context.negated && (
          <span>
            the reviewer{' '}
            <span onClick={this.props.onClick} className="condition-action ">
              is the caller
            </span>
          </span>
        )}
      </div>
    );
  }
}
